module.exports = __webpack_public_path__ + "img/step1-img2.d3f87d37.png";